import services from "../../services";
import Vue from "vue";

const strict = true;
const defaultComponentId = "defaultComponentId";

const state = {
  cities: {}
};

const getters = {
  cities: state => componentId => {
    if (componentId) {
      return state.cities[componentId];
    }
    return state.cities[defaultComponentId];
  }
};

const mutations = {
  reset(state) {
    state.cities = {};
  },
  loadingCities(state, componentId) {
    if (componentId === undefined) {
      componentId = defaultComponentId;
    }
    Vue.set(state.cities, componentId, []);
  },
  citiesLoaded(state, { cities, componentId }) {
    if (componentId === undefined) {
      componentId = defaultComponentId;
    }
    Vue.set(state.cities, componentId, cities);
  },
  errorLoadingCities(state) {
    Vue.set(state.cities, null, []);
  }
};

const actions = {
  async getCities({ commit }, { province, componentId }) {
    if (componentId === undefined) {
      componentId = defaultComponentId;
    }
    try {
      commit("loadingCities", componentId);
      let cities = await services.addressService.getCities(
        commit,
        province.provinceId,
        componentId
      );
      commit("citiesLoaded", { cities, componentId });
    } catch (error) {
      commit("error/setError", error, { root: true });
    }
  }
};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
